import React from 'react';
import {connect} from 'react-redux';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {decimaltoHex, RGBFormatFromDecimal} from '../../../../utilities/common';
import PropTypes from 'prop-types';
import {isEmpty} from '../../../../utilities/validation';
import {parseStudentAnswer} from '../../../../utilities/xml';

const getDataFromNode = function (node) {
    const keys = ['id', 'title', 'text_align', 'x', 'y', 'answer', 'border_style', 'variable', 'bgcolor', 'bgalpha',
        'prompt_highlight_color', 'correct_highlight_color', 'final_highlight_color', 'height', 'width', 'zIndex'];
    return filterNodeProperties(node, keys);
};

class MatchField extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ...getDataFromNode(props.node)
        };
    }

    getColorBasedOnAnswerStatus(answerStatus) {
        const {prompt_highlight_color = 0, correct_highlight_color = 0, final_highlight_color = 0} = this.state;

        if (answerStatus === 'final') {
            return `#${decimaltoHex(final_highlight_color)}`;
        } else if (answerStatus === 'prompt') {
            return `#${decimaltoHex(prompt_highlight_color)}`;
        } else if (answerStatus === 'correct') {
            return `#${decimaltoHex(correct_highlight_color)}`;
        } else {
            return null;
        }
    }

    render() {
        let {width = 0, y = 0, x = 0, height = 0, id = 0, text_align = 'center', bgcolor = '', bgalpha = '',
            border_style = 'solid', zIndex = null, value='', variable = ''} = this.state;
        const {answer = '', fontcolor, answerStatus = '', studentAnswers={}} = this.props;

        if(!isEmpty(studentAnswers) && !isEmpty(variable)) {
            value = parseStudentAnswer(studentAnswers, variable);
        }

        const borderColor = this.getColorBasedOnAnswerStatus(answerStatus);
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
        };
        let heightValue = '100%';
        let widthValue = '100%';

        if (height > 0) {
            heightValue = `${height}px`;
        }
        if (width > 0) {
            widthValue = `${width}px`;
        }

        const inputStyle = {
            textAlign: text_align,
            height: heightValue,
            width: widthValue,
            backgroundColor: !isEmpty(bgcolor) ? RGBFormatFromDecimal(bgcolor, bgalpha) : 'transparent',
            borderColor: (borderColor) ? borderColor : 'transparent',
            borderStyle: border_style,
            color: (fontcolor ? `#${decimaltoHex(fontcolor)}` : 'inherit'),
        };

        if (zIndex !== null) {
            divStyle['zIndex'] = zIndex;
        }

        if(!isEmpty(answer)){
            value = answer;
        }
        return (
            <div className="node match-field" style={divStyle}>
                <input style={inputStyle} type="text" name={id} value={value}
                       onChange={this.props.onChangeMatchField}/>
            </div>
        );
    }
}

MatchField.propTypes = {
    node: PropTypes.object.isRequired,
    onChangeMatchField: PropTypes.func.isRequired,
    answer: PropTypes.string,
    answerStatus: PropTypes.string,

};

const mapStateToProps = (state) => {
    return {
        studentAnswers: state.answers.list
    };
};

const MatchFieldNode = connect(
    mapStateToProps,
    null
)(MatchField);

export default MatchFieldNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/match-field-node.js